import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

const SupportSection = () => {
  // ✅ WhatsApp direct chat
  const handleWhatsAppClick = () => {
    const phoneNumber = "+918827055967"; // include country code, e.g. +91 for India
    const message = encodeURIComponent("Hello, I need help deciding about a course!");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  // ✅ Gmail compose link
  const handleMailClick = () => {
    const email = "securtech.in@gmail.com"; // your business email
    const subject = encodeURIComponent("Course Inquiry");
    const body = encodeURIComponent("Hello,\n\nI’d like to know more about your courses.\n\nThanks!");
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`, "_blank");
  };

  return (
    <section className="support-section">
      <div className="support-box">
        <h2>Need Help Deciding?</h2>
        <p>Our experts are just one click away. Reach out now!</p>

        <div className="support-actions">
          <button onClick={handleWhatsAppClick} className="support-button phone">
            <FaPhoneAlt />
            WhatsApp Us
          </button>

          <button onClick={handleMailClick} className="support-button inquiry">
            <FiMail />
            Make an Inquiry
          </button>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
